// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper__2mynG","disable":"Card_disable__300y4"};